export default "__VITE_ASSET__2d0e2912__"